export const NOTIFICATION_URL = Object.freeze({
  name: 'notifications.list',
  path: '/notifications',
});

export const NOTIFICATION_TYPES = Object.freeze({
  article_tag: 'TAG',
  question_tag: 'TAG',
  article_user: 'ARTICLE',
  article_update: 'ARTICLE',
  new_article: 'ARTICLE',
  new_question: 'QUESTION',
  question_user: 'QUESTION',
  new_answer: 'ANSWER',
  new_track: 'TRACK',
  track_update: 'TRACK',
  followed_track_update: 'TRACK',
});

export const NOTIFICATION_LINKS = Object.freeze({
  article_tag: 'DaraArticleLink',
  article_user: 'DaraArticleLink',
  article_update: 'DaraArticleLink',
  new_article: 'DaraArticleLink',
  question_tag: 'DaraQuestionLink',
  new_question: 'DaraQuestionLink',
  question_user: 'DaraQuestionLink',
  new_answer: 'DaraQuestionLink',
  new_track: 'DaraTrackLink',
  track_update: 'DaraTrackLink',
  followed_track_update: 'DaraTrackLink',
});

export const NOTIFICATION_ICONS = Object.freeze({
  TAG: 'hash',
  ARTICLE: 'file-earmark-text',
  ANSWER: 'exclamation-lg',
  QUESTION: 'question-lg',
  TRACK: 'files',
});
